<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'IP Interface Address Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="addNewRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <div
                  @click="editSelectRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="delSelectRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
            <!-- 选择接口列表 -->
            <span style="float: left">
              <select class="form-control" v-model="selectedIfName">
                <option
                  v-if="vlanIfAddrTable.data && vlanIfAddrTable.data.length === 0"
                  value="-1"
                >
                  No Interface
                </option>
                <option
                  v-for="opt in vlanIfAddrTable.data"
                  :key="opt.ifName"
                  :value="opt.ifName"
                >
                  {{ opt.ifName }}
                </option>
              </select>
            </span>
        <span style="float: right">
        <div class="pageButton">
          <button type="button" class="btn btn-primary" @click="clkApply()">
            {{ "Apply" }}
          </button>
          <span style="margin-left: 10px">
            <button
              type="button"
              class="btn btn-default"
              style="min-width: 77px"
              @click="clkCancel()"
            >
              {{ "Cancel" }}
            </button>
          </span>
        </div>
        </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    @change="selectall()"
                    v-model="selAll"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th
                  v-for="(value, key) in vlanIfAddrTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in selectedIntf(this.selectedIfName)"
                :key="row.index"
                :class="{
                  info: row.rowStatus === 'new' || row.rowStatus === 'edit',
                  delete: row.rowStatus === 'del',
                }"
                @dblclick="editDoubleClickRow(row)"
                @click.stop="
                  row.selected =
                    row.rowStatus === '' ? !row.selected : row.selected
                "
                style="
                  -moz-user-select: none; /*火狐*/
                  -webkit-user-select: none; /*webkit浏览器*/
                  -ms-user-select: none; /*IE10*/
                  -khtml-user-select: none; /*早期浏览器*/
                  user-select: none;
                "
              >
                <td width="40px">
                  <div v-if="row.rowStatus === ''">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + row.index"
                    />
                    <label></label>
                  </div>
                  <div v-else class="revocate" @click.stop="undoRow(row)">
                    <i class="fa fa-undo"></i>
                  </div>
                </td>
                <td
                  v-for="(value, key) in printableRow(row)"
                  :key="key"
                  :title="value"
                >
                  <!-- ipAddr 编辑 -->
                  <div
                    v-if="
                      key === 'ipAddr' &&
                      (row.rowStatus === 'new')
                    "
                  >
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_ip_check(row, 1) }"
                    >
                      <input
                        type="text"
                        v-model="row.newIpAddr"
                        class="form-control table-edit"
                        maxlength="15"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_ip_check(row, 1) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_ip_check(row, 1) ? 'block' : 'none',
                        }"
                        >{{ input_ip_check(row, 1) }}</small
                      >
                    </span>
                  </div>
                  <!-- ipMask 编辑 -->
                  <div v-else-if="key === 'ipMask' && row.rowStatus === 'new'">
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_ip_check(row, 2) }"
                    >
                      <input
                        type="text"
                        v-model="row.newIpMask"
                        class="form-control table-edit"
                        maxlength="15"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_ip_check(row, 2) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_ip_check(row, 2) ? 'block' : 'none',
                        }"
                        >{{ input_ip_check(row, 2) }}</small
                      >
                    </span>
                  </div>
                  <!-- ifPrimary 新增时切换成是否override -->
                  <div v-else-if="key === 'ifPrimary' && (row.rowStatus === 'new')">
                    <input
                      type="checkbox"
                      v-model="row.newIpOverride"
                      class="form-control table-edit"
                      :id="'idIpOverride' + row.index"
                    />
                    <label :for="'idIpOverride' + row.index">Override {{ row.newIpOverride }}</label>
                  </div>
                  <!-- ifPrimary 编辑 -->
                  <div v-else-if="key === 'ifPrimary' && (row.rowStatus === 'edit')">
                    <input
                      type="checkbox"
                      v-model="row.newIfPrimary"
                      class="form-control table-edit"
                      :id="'idIfPrimary' + row.index"
                    />
                    <label :for="'idIfPrimary' + row.index">{{ row.newIfPrimary }}</label>
                  </div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>

import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "vlanIfAddrTable",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.ipconfigifaddr,
      vlanIfAddrTable: "",
      tVlanIfAddrTable: "",
      selectedIfName: "",
      selAll: false,
      iBox: {},
      newRowCount: 0,
      maxNewRowCount: 5,
      newRow: {
        index: 0,
        ipAddr: "",
        ipMask: "",
        ipOverride: false,
        ifPrimary: true,
        rowStatus: "new",
        newIpAddr: "",
        newIpMask: "",
        newIpOverride: false,
        newIfPrimary: false
      }
    }
  },
  created() {
    this.loadvlanifaddr()
  },
  methods: {
    loadvlanifaddr() {
      get("vlanIfAddrTable")
        .then((res) => {
          this.vlanIfAddrTable = res.data
          this.dataInit()
        })
        .catch((err) => {
          this.vlanIfAddrTable = en.vlanIfAddrTable
          this.dataInit()
        })
    },

    /* 页面数据初始化 */
    dataInit() {
        this.tVlanIfAddrTable = JSON.parse(JSON.stringify(this.vlanIfAddrTable.data))
        this.tVlanIfAddrTable.forEach((element) => {
	        element.ifIp.forEach((elem) => {
	        this.$set(elem, "rowStatus", "")
	        this.$set(elem, "selected", false)
	        this.$set(elem, "newIpAddr", "")
	        this.$set(elem, "newIpMask", "")
	        this.$set(elem, "ifPrimary", (elem["ifPrimary"] === "true" || elem["ifPrimary"] === true) ? true : false)
	        this.$set(elem, "newIfPrimary", elem["ifPrimary"])
	        })
        })
        if (
            this.vlanIfAddrTable.data.length &&
            this.vlanIfAddrTable.data[0].ifName !== undefined
          )
            this.selectedIfName = this.vlanIfAddrTable.data[0].ifName
        this.selAll = false
        this.newRowCount = 0
    },

    /* 页面提交函数 */
    clkApply() {
      var postData = {}
      var newRows = []
      var editRows = []
      var delRows = []
      var vti = this.tVlanIfAddrTable.find((o) => o["ifName"] === this.selectedIfName)
      var vt = vti.ifIp;
      for (var v = 0; v < vt.length; v++) {
        if (
          vt[v]["rowStatus"] !== "new" &&
          vt[v]["rowStatus"] !== "edit" &&
          vt[v]["rowStatus"] !== "del"
        )
          continue
        if (vt[v]["rowStatus"] === "new" || vt[v]["rowStatus"] === "edit") {
          // 单元参数再次检查
          if (vt[v]["rowStatus"] === "new" && (this.input_ip_check(vt[v], 1) || this.input_ip_check(vt[v], 2))) {
            this.showAlertBox("warn", "warnning", "Fix the mistake first!")
            return
          }
          // 行内逻辑检查
        }
        // 新行添加冲突检查，编辑行前后对比检查，而后准备数据
        if (vt[v]["rowStatus"] === "new") {
          // 添加新行操作，进行冲突检查
          var skip = false
          for (var d = 0; d < vt.length; d++) {
            if ((d < v && vt[d]["rowStatus"] === "new") || v === d) continue
            // 冲突检查
            /*if (
              vt[v]["newIfType"] ==
              (vt[d]["rowStatus"] === "new" ? vt[d]["newIfType"] : vt[d]["ifType"]) &&
              ((vt[v]["newIfType"] == "0" ? "VLAN-IF" : "superVLAN-IF") + vt[v]["newVlanId"]) ===
              (vt[d]["rowStatus"] === "new" ? ((vt[d]["newIfType"] == "0" ? "VLAN-IF" : "superVLAN-IF") + vt[d]["newVlanId"]) : vt[d]["ifName"])
            ) {
              var msg = (vt[v]["newIfType"] == "0" ? "VLAN-IF" : "superVLAN-IF") + vt[v]["newVlanId"]
              if (vt[d]["rowStatus"] === "new") {
                msg += " repeat add!"
              } else if (vt[d]["rowStatus"] === "del") {
                msg += " add and delete conflict!"
              } else {
                msg += " already exist!"
              }
              this.showAlertBox("warn", "Warnning", msg)
              return
            }*/
          }
          if (
            vt[v]["newIpAddr"] === this.newRow["newIpAddr"] && vt[v]["newIpMask"] === this.newRow["newIpMask"]
          )
            continue
          var row = { ifName: this.selectedIfName }
          if (vt[v]["newIpAddr"] !== this.newRow["newIpAddr"] || vt[v]["newIpMask"] !== this.newRow["newIpMask"])
          {
            row["ipAddr"] = vt[v]["newIpAddr"]
            row["ipMask"] = vt[v]["newIpMask"]
          }
          if (vt[v]["newIpOverride"] !== this.newRow["newIpOverride"])
            row["ipOverride"] = vt[v]["newIpOverride"]
          newRows.push(row)
        } else if (vt[v]["rowStatus"] === "edit") {// 编辑操作，进行编辑前后变更检查
          if (
            vt[v]["ifPrimary"] === vt[v]["newIfPrimary"]
          )
            continue
          var row = { ifName: this.selectedIfName }
          row["ipAddr"] = vt[v]["ipAddr"]
          if (vt[v]["newIfPrimary"] !== vt[v]["ifPrimary"])
            row["ifPrimary"] = vt[v]["newIfPrimary"]
          editRows.push(row)
        } else if (vt[v]["rowStatus"] === "del") {// 删除操作
          var row = { ifName: this.selectedIfName }
          row["ipAddr"] = vt[v]["ipAddr"]
          row["ipMask"] = vt[v]["ipMask"]
          delRows.push(row)
        }
      }
      if (!newRows.length && !editRows.length && !delRows.length) {
        this.showAlertBox("info", "Info", "Nothing to do!")
        return
      }
      if (newRows.length) postData["add"] = newRows
      if (editRows.length) postData["edit"] = editRows
      if (delRows.length) postData["del"] = delRows
      post("vlanIfAddrTable", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              "Message",
              res.data.msg !== undefined ? res.data.msg : "Unknown error!"
            )
          this.loadvlanifaddr()
        })
        .catch((err) => {
          this.showAlertBox("critical", "Error", err)
        })
    },

    /* 页面恢复函数 */
    clkCancel() {
      this.dataInit()
    },

    /* 参数输入IP检查 */
    input_ip_check(row, value) {
      var vt = ""
      if (value == 1)
        vt = row["newIpAddr"]
      else if (value == 2)
        vt = row["newIpMask"]

        if (vt != "") {
          if (
            vt.match(
              /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/
            ) == null
          ) {
            return "invalid ip address"
          } else {
            var id = vt.split(".")
            let ip0 = Number(id[0])
            let ip1 = Number(id[1])
            let ip2 = Number(id[2])
            let ip3 = Number(id[3])
            if (
              id.length !== 4 ||
              ip0 < 0 ||
              ip0 > 255 ||
              ip1 < 0 ||
              ip1 > 255 ||
              ip2 < 0 ||
              ip2 > 255 ||
              ip3 < 0 ||
              ip3 > 255
            )
              return "invalid ip address"
          }
        }

      return null
    },

    /* 表头添加新行 */
    addNewRow() {
      var vti = this.tVlanIfAddrTable.find((o) => o["ifName"] === this.selectedIfName)
      var vt = vti.ifIp;
      if (this.newRowCount >= this.maxNewRowCount)
        this.showAlertBox("info", "Warnning", "Too many new row.")
      else {
        vt.unshift(JSON.parse(JSON.stringify(this.newRow)))
        this.newRowCount++
        // 获取新行索引
        var vt1 = JSON.parse(JSON.stringify(vt))
        vt1.sort((a, b) => {
          return a.index - b.index
        })
        for (var idx = 1; idx <= 4094; idx++) {
          if (vt.length <= idx || idx != vt1[idx].index) {
            vt[0].index = idx
            break
          }
        }
      }
    },

    /* 双击编辑行 */
    editDoubleClickRow(row) {
      if (row["rowStatus"] === "") {
        row["rowStatus"] = "edit"
        row["selected"] = false
        row["ifPrimary"] = (row["ifPrimary"] === "true" || row["ifPrimary"] === true) ? true : false
        row["newIfPrimary"] = row["ifPrimary"]
      }
    },

    /* 编辑选择的行 */
    editSelectRow() {
      var vti = this.tVlanIfAddrTable.find((o) => o["ifName"] === this.selectedIfName)
      var vt = vti.ifIp;
      vt.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "edit"
          element["selected"] = false
          element["ifPrimary"] = (element["ifPrimary"] === "true" || element["ifPrimary"] === true) ? true : false
          element["newIfPrimary"] = element["ifPrimary"]
        }
      })
    },

    /* 删除选择的行 */
    delSelectRow() {
      var vti = this.tVlanIfAddrTable.find((o) => o["ifName"] === this.selectedIfName)
      var vt = vti.ifIp;
      vt.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "del"
          element["selected"] = false
        }
      })
    },

    /* 撤销行操作 */
    undoRow(row) {
      var vti = this.tVlanIfAddrTable.find((o) => o["ifName"] === this.selectedIfName)
      var vt = vti.ifIp;
      if (row["rowStatus"] === "new") {
        var fi = vt.findIndex((r) => r.index === row.index)
        if (fi !== -1) {
          vt.splice(fi, 1)
          this.newRowCount--
        }
      } else if (row["rowStatus"] === "edit" || row["rowStatus"] === "del") {
        row["rowStatus"] = ""
        row["selected"] = false
      }
    },

    /* 选中的接口打印 */
    selectedIntf(selIfName) {
      if (this.tVlanIfAddrTable === undefined) return undefined

      var ifaces = this.tVlanIfAddrTable.find(
        (o) => o.ifName === selIfName
      )

      return ifaces.ifIp
    },

    /* 行有效打印 */
    printableRow(row) {
      /*if (this.tVlanIfAddrTable === undefined) return

      var ifAddrs = this.tVlanIfAddrTable.find((o) => o.ifName === this.selectedIfName)
      if (ifAddrs === undefined) return

      return ifAddrs.ifIp*/

      var prow = {}
      //for (var r in row) {
        //if (r["ifName"] !== this.selectedIfName) continue
          for (var c in row) { //r["ifIp"]
          if (
          c === "rowStatus" ||
          c === "selected" ||
          c === "newIpAddr" ||
          c === "newIpMask" ||
          c === "ipOverride" ||
          c === "newIpOverride" ||
          c === "newIfPrimary"
          )
          continue
          prow[c] = row[c] //r["ifIp"][c]
        }
      //}
      return prow
    },

    /* 选择全部行 */
    selectall() {
      var vti = this.tVlanIfAddrTable.find((o) => o["ifName"] === this.selectedIfName)
      var vt = vti.ifIp;
      vt.forEach((element) => {
        if (element["rowStatus"] === "") element["selected"] = this.selAll
      })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
